import styled from "@emotion/styled"

export const Container  = styled.div`
    position: fixed;
    margin: 0 auto;
    top: 50% !important;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0s linear;

    mix-blend-mode: normal;
    opacity: ${(props) => (props.dark ? 0.1 : 1)};
    @media screen and (max-width: 768px) {
        height: 120%;
        img {
          max-width: fit-content;
          height: 100%;
        }
    }
`;
